import { privateAxios } from '@/services/api'

export const _getAllPresentations = () => {
    return privateAxios.get('/presentations')
        .then(response => response.data)
}

export const _getPresentations = (data) => {
    return privateAxios.post('/presentations/search', data)
        .then(response => response.data)
}

export const _getPresentation = (id) => {
    return privateAxios.get(`/presentations/${id}`)
        .then(response => response.data)
}

export const _addPresentation = (data) => {
    return privateAxios.post('/presentations', data)
        .then(response => response.data)
}

export const _updatePresentation = (data) => {
    return privateAxios.put('/presentations', data)
        .then(response => response.data)
}

export const _deletePresentation = (id) => {
    return privateAxios.delete(`/presentations/${id}`)
        .then(response => response.data)
}

export const _loadVersions = (id) => {
    return privateAxios.get(`/presentations/${id}/versions`)
        .then(response => response.data)
}

export const _saveVersion = (data, id) => {
    return privateAxios.post(`/presentations/${id}/versions`, data)
        .then(response => response.data)
}

export const _publishVersion = (id, version) => {
    return privateAxios.put(`/presentations/${id}/versions/${version}`)
        .then(response => response.data)
}
